<template>
  <div>
    <div class="menu-list" v-if="isMenuShow" @click.stop>
      <div @click="enlarge"><span class="firsts1"></span><span class="last">放大</span></div>
      <div @click="narrow"><span class="firsts2"></span><span class="last">缩小</span></div>
      <div @click="fullScreenClick"><span class="firsts3"></span><span class="last">全屏</span></div>
      <div @click="openShareDialogs" v-if="!isStaticBook"><span class="firsts4"></span><span class="last">分享</span></div>
    </div>
    <ShareDilalog ref="share" :title="isPaper ? '分享数字报' : '分享电子书刊'" :qrObj="qrObj" />
  </div>
</template>

<script>
import ShareDilalog from '@components/books/components/ShareDialog'
export default {
  name: 'menuList',
  components: {ShareDilalog},
  data() {
    return {
      isMenuShow: false,
      qrObj: {
        value: '',
        iframeUrl: ''
      }
    }
  },
  computed: {
    isStaticBook() {
      return this.$store.state.common.isStaticBook
    },
    isPaper() {
      return this.$store.state.book.isPaper
    }
  },
  methods: {
    //放大
    enlarge() {
      this.$parent.enlarge()
    },
    //缩小
    narrow() {
      this.$parent.narrow()
    },
    //全屏
    fullScreenClick() {
      this.$parent.fullScreenClick()
    },
    openShareDialogs() {
      this.$refs.share.dialogVisible = true
      this.qrObj.value = window.location.href
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      $('.menu-list').hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-list {
  width: 80px;
  // height: 140px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10000;
  div {
    width: 80px;
    height: 35px;
    display: flex;
    padding-left: 8px;
    padding-top: 3px;
    cursor: pointer;
    .firsts1,
    .firsts2,
    .firsts3,
    .firsts4 {
      width: 30px;
      height: 30px;
      display: inline-block;
      background: cover;
    }
    .firsts1 {
      background: url('../../assets/imgs/add.png') no-repeat center center;
    }
    .firsts2 {
      background: url('../../assets/imgs/jian.png') no-repeat center center;
    }
    .firsts3 {
      background: url('../../assets/imgs/quanPing.png') no-repeat center center;
    }
    .firsts4 {
      background: url('../../assets/imgs/erweima.png') no-repeat center center;
    }
    .last {
      width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      font-size: 14px;
      color: #fff;
      display: inline-block;
    }
  }
}
</style>
